// FetchOffersOverview POST /api/2.0/offers/fetch_offers_overview
import { api } from "services/api/service";
import { API_GET_RESERVED_NON_MEMBER, API_CREATE_NON_MEMBER_USERS } from "constants/api";
import type { ApiResponse } from "services/api/types";

export const getReservedNonMembers = async (): Promise<ApiResponse<any>> => {
	return (await api()).post(API_GET_RESERVED_NON_MEMBER);
};

interface CreationPayload {
	non_member_ahcs: number;
	non_member_ao: number;
	non_member_go: number;
}

export const createNonMembersAccount = async (payload: CreationPayload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_CREATE_NON_MEMBER_USERS, payload);
};
